/** @format */
import {
    mapValues,
    map,
    filter,
    toPairs,
    orderBy,
    groupBy,
    sortBy,
    omitBy,
    flatMap,
    uniq,
    reject,
    keyBy,
    concat,
    compact,
    join,
    values,
    reduce,
    some,
    head,
    get,
    find,
    last,
} from 'lodash-es';

/**
 * @deprecated do not use chain, try to use native js instead! Reason for this is that lodash-es chain does not support tree shaking(sub objects of chain are not being imported)
 */
export const sisuChain = <T>(input: T) => {
    let value: any = input;
    const chainableFunctions = {
        map,
        filter,
        toPairs,
        orderBy,
        groupBy,
        sortBy,
        omitBy,
        flatMap,
        uniq,
        reject,
        keyBy,
        concat,
        compact,
        join,
        values,
        reduce,
        some,
        head,
        get,
        find,
        mapValues,
        last,
    };
    const wrapper = {
        ...mapValues(chainableFunctions, (f: any) => (...args: any[]) => {
            // lodash always puts input as the first argument
            value = f(value, ...args);
            return wrapper;
        }),
        value: () => value,
    };
    return wrapper;
};
